import { render, staticRenderFns } from "./ScreenshotModal.vue?vue&type=template&id=125d2d84&scoped=true"
import script from "./ScreenshotModal.vue?vue&type=script&lang=js"
export * from "./ScreenshotModal.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotModal.vue?vue&type=style&index=0&id=125d2d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d2d84",
  null
  
)

export default component.exports